export const onlyInteger = () => {
  return {
    restrict: 'A',
    link: (scope, element, attrs) => {
      element.on('keypress', (event) => {
        if (!isIntegerChar()) {
          event.preventDefault()
        }
        function isIntegerChar () {
          return /[0-9]|-/.test(
            String.fromCharCode(event.which))
        }
      })
    }
  }
}

export const errSrc = () => {
  return {
    scope: { errSrcResolve : '&' },
    link: function (scope, element, attrs) {
        let setSrcToErr = function () {
            if (attrs.src !== attrs.errSrc) {
                attrs.$set('src', attrs.errSrc)
            }
        };

        let onError = function(){
            if(!scope.errSrcResolve()) return setSrcToErr();
            scope.errSrcResolve()(setSrcToErr);
        };

        element.bind('error', onError);
    }
  }
};



// WEBPACK FOOTER //
// ./src/app.directives.js